<template>
  <div>
    <van-pull-refresh
      v-if="immediate"
      v-model="refreshing"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model:error="error"
        v-model:loading="loading"
        error-text="加载失败，点击重试"
        :finished="finished"
        @load="onLoad"
      >
        <ul class="article-list">
          <li v-for="(item, index) in list" :id="'id' + item.Id" :key="item.Id">
            <div class="li-hd flex flex-align-center">
              <div class="face">
                <a
                  href="javascript:;"
                  @click.stop="$go('Userpost', { query: { ...item.UserInfo } })"
                >
                  <van-image
                    height="44"
                    lazy-load
                    round
                    :src="$getAvatar(item.UserInfo && item.UserInfo.Avatar)"
                    width="44"
                  />
                </a>
              </div>
              <div class="flex-1 flex flex-v">
                <div v-if="item.UserInfo" class="flex">
                  <a
                    href="javascript:;"
                    @click.stop="$go('Mypost', { query: { ...item.UserInfo } })"
                  >
                    <h2>
                      {{
                        item.UserInfo.NickName || item.UserInfo.UserName || '--'
                      }}
                    </h2>
                  </a>
                </div>
              </div>
              <div class="tools">
                <article-tools :data="item" @delDone="delDone(index)" />
              </div>
            </div>
            <div
              class="li-bd"
              @click.stop="$go('CaseDetail', { params: { id: item.Id } })"
            >
              <h2>
                <van-tag
                  v-if="item.Status == 1"
                  plain
                  size="medium"
                  type="warning"
                >
                  审核中
                </van-tag>
                <van-tag
                  v-if="item.Status == 2"
                  plain
                  size="medium"
                  type="danger"
                >
                  审核不通过
                </van-tag>
                <van-tag
                  v-if="item.Recommendable"
                  plain
                  size="medium"
                  type="danger"
                >
                  置顶
                </van-tag>
                {{ item.Title }}
              </h2>
              <div class="clearfix">
                <a
                  v-if="item.Topic"
                  class="topic"
                  href="javascript:;"
                  @click.stop="$go('CaseList', { query: { ...item.Topic } })"
                >
                  <h2>
                    <span>#</span>
                    <span>{{ item.Topic.TagLabel }}</span>
                    <span>#</span>
                    <van-icon
                      v-if="item.Topic.IsHotTag"
                      color="#ee0a24"
                      name="fire"
                      size="14"
                    />
                  </h2>
                </a>

                <div
                  v-if="!item.isCut"
                  class="html"
                  v-html="getContent(item.Text)"
                ></div>
                <div
                  v-if="item.isCut && item.showAllBtn"
                  class="html"
                  v-html="getContent(item.Text, 100)"
                ></div>
                <div
                  v-if="item.isCut && !item.showAllBtn"
                  class="html"
                  v-html="getContent(item.Text)"
                ></div>
                <p v-if="item.isCut && item.showAllBtn">...</p>
                <a
                  v-if="item.isCut && item.showAllBtn"
                  class="link"
                  href="javascript:;"
                  @click.stop="showDetail(item)"
                >
                  全文
                </a>
                <a
                  v-if="item.isCut && !item.showAllBtn"
                  class="link"
                  href="javascript:;"
                  @click.stop="handlePackup(item)"
                >
                  收起
                </a>
              </div>
              <ul
                class="img-list flex flex-wrap"
                :class="'list-' + item.Image.length"
              >
                <li v-for="(item2, index2) in item.Image" :key="index2">
                  <van-image
                    v-if="item2"
                    fit="cover"
                    lazy-load
                    :src="api.FileHost + item2"
                    @click.stop="showImg(item.Image, index2)"
                  />
                </li>
              </ul>
              <ul
                class="video-list-v2 flex flex-wrap"
                :class="'list-' + item.Video.length"
                @click.stop=""
              >
                <li
                  v-for="(item2, index2) in item.Video"
                  :key="index2"
                  ref="videobox"
                >
                  <video
                    v-if="item2"
                    class="video"
                    controls
                    crossOrigin="Anonymous"
                    muted
                    playsinline
                    :poster="item.VideoCover[index2] || poster"
                    preload="auto"
                    :src="api.FileHost + item2"
                    webkit-playsinline="true"
                    x-webkit-airplay="true"
                    x5-video-player-type="h5"
                  ></video>
                </li>
              </ul>
            </div>
            <div v-if="item.Status == 3" class="li-fd flex">
              <div class="flex-1 date">
                {{ getTimer(item.LastUpdatedDate) }}
              </div>
              <a
                class="zan flex flex-alice-center"
                :class="{ like: item.Article && item.Article.IsPraise }"
                href="javascript:;"
                @click.stop="zanHandle(item)"
              >
                <van-icon
                  :name="
                    item.Article && item.Article.IsPraise ? 'like' : 'like-o'
                  "
                  size="20"
                />
                <span v-if="item.Article" class="num">
                  {{ item.Article.PraiseNum }}
                </span>
              </a>
            </div>
          </li>
        </ul>
      </van-list>
      <van-empty
        v-if="!list.length && !loading"
        description="暂无数据"
        :image="isSearch ? 'search' : 'default'"
      />
      <!-- <copy-right v-if="!isSearch" /> -->
    </van-pull-refresh>
    <DragBall @click="$go('CaseAdd')">
      <div class="flex flex-v flex-pack-center flex-align-center">
        <van-icon name="plus" size="18" />
        <p class="mt3">发帖</p>
      </div>
    </DragBall>
  </div>
</template>
<script>
  import DragBall from '@/components/DragBall'
  import ArticleTools from '../ArticleTools'
  import store from '@/store'
  import api from '@/api'
  import { ImagePreview, Toast } from 'vant'
  import { getTimer } from '@/utils/filters'

  //import CopyRight from '@/components/Copyright'
  export default {
    components: {
      ArticleTools,
      // eslint-disable-next-line vue/no-unused-components
      DragBall,
      // CopyRight,
    },
    props: {
      url: {
        type: String,
        default: 'case/PostSelectByTenant',
      },
      params: {
        type: Object,
        default() {
          return {}
        },
      },
      // 是否是搜索页
      isSearch: {
        type: Boolean,
        default: false,
      },
      // 是否是后台预览
      isPreview: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        api,
        immediate: true,
        list: [],
        loading: false,
        error: false,
        finished: false,
        refreshing: false,
        form: {
          //TenantId: store.getters['user/getTenantId'],
          PageIndex: 1,
          PageSize: 10,
        },
        poster: null,
        getTimer,
      }
    },
    watch: {
      params: {
        handler(newVal, oldVal) {
          this.immediate = true
          this.list = []
          this.form.PageIndex = 1
          //解决搜索加载2次问题
          //if (newVal && newVal.query && !oldVal) return
          this.onLoad()
        },
        deep: true,
      },
      'list.length': {
        handler(newVal, oldVal) {
          this.$nextTick(() => {
            //console.log(newVal, oldVal)
            document.addEventListener('WeixinJSBridgeReady', function () {
              let itemArr = document.querySelectorAll('video')

              for (let i = 0; i < itemArr.length; i++) {
                //console.log('this.$refs.videobox', itemArr[i])
                itemArr[i].play()
                // setTimeout(() => {
                //   itemArr[i].pause()
                // }, 0)
              }
            })
            this.setCover()
          })
        },
        deep: true,
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      async init() {
        //var u = navigator.userAgent
        //var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
        //if (!isiOS) {
        const logo = (await store.getters['user/getTenant']).LogoLarge
        this.poster = api.FileHost + logo
        //}
      },
      setCover() {
        const list = this.list
        //console.log('list', list)
        for (let index = 0; index < list.length; index++) {
          const item = list[index]
          if (item.Video.length) {
            //console.log('item', item)
            this.createCover(item)
          }
        }
      },

      async createCover(item) {
        const vidoe = item.Video
        if (item.Video.length == item.VideoCover.length) return
        for (let index = 0; index < vidoe.length; index++) {
          const item2 = vidoe[index]
          //console.log('item2', item2)
          const url = api.FileHost + item2 //视频地址
          const base64 = await this.getVideoBase64(url)
          item.VideoCover.push(base64)
        }
      },

      getVideoBase64(url) {
        return new Promise(function (resolve) {
          let dataURL = ''
          const video = document.createElement('video')
          video.setAttribute('crossOrigin', 'anonymous')
          video.setAttribute('src', url)
          video.setAttribute('preload', 'auto')
          //video.setAttribute('autoplay', true)
          video.addEventListener('loadeddata', function () {
            const canvas = document.createElement('canvas')
            // console.log('video.clientWidth', video.videoWidth) // 视频宽
            // console.log('video.clientHeight', video.videoHeight) // 视频高
            const width = video.videoWidth || 400 // canvas的尺寸和图片一样
            const height = video.videoHeight || 240 // 设置默认宽高为  400  240
            canvas.width = width
            canvas.height = height
            canvas.getContext('2d').drawImage(video, 0, 0, width, height) // 绘制canvas
            dataURL = canvas.toDataURL('image/jpeg') // 转换为base64
            resolve(dataURL)
          })
        })
      },

      goto(name, option) {
        this.$router.push(Object.assign(option, { name }))
      },

      showDetail(item) {
        item.showAllBtn = false
        const params = {
          ArticleId: item.Id,
          OperationType: 1,
        }
        let url = 'case/ArticleOperationIncrease'
        store
          .dispatch(url, params)
          .then((data) => {})
          .catch((e) => {
            console.log(e)
          })
      },

      async onLoad() {
        this.error = false
        if (!this.immediate || !this.url || !this.params) {
          return
        }
        //setTimeout(() => {
        if (this.refreshing) {
          this.list = []
          this.form.PageIndex = 1
          //refreshing.value = false
          this.finished = false
        }
        this.form.TenantId = (await store.getters['user/getTenant']).TenantId
        Object.assign(this.form, this.params)
        if (this.isSearch && this.params && !this.params.query) {
          this.loading = false
          return
        }
        store
          .dispatch(this.url, this.form)
          .then(async (data) => {
            const resList = data.Data.CurrentPage
            if (resList.length) {
              const userIdsList = []
              const topicIdsList = []
              const ArticleIdsList = []
              resList.forEach((item) => {
                if (item.CreatedBy) userIdsList.push(item.CreatedBy)
                if (item.TopicId && item.TopicId != '0')
                  topicIdsList.push(item.TopicId)
                if (item.Id) ArticleIdsList.push(item.Id)
              })
              await this.setUserInfo(resList, userIdsList)
              await this.setTopicInfo(resList, topicIdsList)
              await this.setArticleInfo(resList, ArticleIdsList)
              resList.forEach((item) => {
                if (item.Text.length > 100) {
                  item.isCut = true //是否需要裁剪正文
                  item.showAllBtn = true
                } else {
                  item.isCut = false
                }
                item.VideoCover = []
                this.list.push(item)
              })
              console.log('this.list', this.list)
              this.form.PageIndex++
            } else {
              this.finished = true
            }
            if (this.list.length >= data.Data.Total) {
              this.finished = true
            }
            setTimeout(() => {
              this.refreshing = false
              this.loading = false
            }, 800)
          })
          .catch((e) => {
            setTimeout(() => {
              this.error = true
              // finished.value = true
              this.loading = false
            }, 500)
          })
      },

      async setUserInfo(resList, list) {
        const tenant = await store.getters['user/getTenant']
        return new Promise((resolve, reject) => {
          const arr = Array.from(new Set(list))

          store
            .dispatch('user/GetUserList', {
              userIDs: arr,
              tenantId: tenant.TenantId,
            })
            .then((data) => {
              const d = data.Data
              resList.forEach((item) => {
                d.forEach((item2) => {
                  if (item.CreatedBy === item2.UserId) {
                    item.UserInfo = item2
                  }
                })
              })
              resolve()
            })
            .catch((e) => {
              resolve()
            })
        })
      },
      setTopicInfo(resList, list) {
        return new Promise((resolve, reject) => {
          const arr = Array.from(new Set(list))
          store
            .dispatch('case/TopicTagGetByIds', arr)
            .then((data) => {
              const d = data.Data
              resList.forEach((item) => {
                d.forEach((item2) => {
                  if (item.TopicId === item2.TagId) {
                    item.Topic = item2
                  }
                })
              })
              resolve()
            })
            .catch((e) => {
              resolve()
            })
        })
      },
      setArticleInfo(resList, list) {
        return new Promise((resolve, reject) => {
          const arr = Array.from(new Set(list))
          store
            .dispatch('case/GetBatchArticleStatistics', arr)
            .then((data) => {
              const d = data.Data
              resList.forEach((item) => {
                d.forEach((item2) => {
                  if (item.Id === item2.ArticleId) {
                    item.Article = item2
                  }
                })
              })
              resolve()
            })
            .catch((e) => {
              resolve()
            })
        })
      },

      getContent(data, num) {
        let res = data
        if (num) {
          res = res.substring(0, num)
        }
        res =
          res.charAt(res.length - 1) == '<'
            ? res.substring(0, res.length - 1)
            : res
        res = res.replace(/\n/g, '<br/>')
        return res
      },

      onRefresh() {
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        this.onLoad()
      },

      showImg(list, index) {
        const arr = []
        list.forEach((item) => {
          arr.push(api.FileHost + item)
        })
        ImagePreview({
          images: arr,
          startPosition: index,
          showIndex: false,
          showIndicators: true,
          overlayStyle: {
            background: '#000',
          },
          //closeable: true,
        })
      },

      zanHandle(item, type = 3) {
        const params = {
          ArticleId: item.Id,
          OperationType: type,
        }
        let url = 'case/ArticleOperationIncrease'
        if (item.Article && item.Article.IsPraise) {
          url = 'case/ArticleOperationCancel'
        }
        store
          .dispatch(url, params)
          .then((data) => {
            if (item.Article.IsPraise) {
              item.Article.PraiseNum--
              item.Article.IsPraise = false
              //Toast.success('取消点赞成功')
            } else {
              item.Article.IsPraise = true
              item.Article.PraiseNum++
              //Toast.success('点赞成功')
            }
          })
          .catch((e) => {
            console.log(e)
            Toast.fail('点赞失败')
          })
      },

      // getTimer(stringTime) {
      //   var minute = 1000 * 60
      //   var hour = minute * 60
      //   var day = hour * 24
      //   var week = day * 7
      //   var month = day * 30
      //   var time1 = new Date().getTime() //当前的时间戳
      //   var time2 = Date.parse(new Date(stringTime)) //指定时间的时间戳
      //   var time = time1 - time2

      //   var result = null
      //   if (time < 0) {
      //     result = ''
      //   } else if (time / month >= 1) {
      //     result = parseInt(time / month) + '月前'
      //   } else if (time / week >= 1) {
      //     result = parseInt(time / week) + '周前'
      //   } else if (time / day >= 1) {
      //     result = parseInt(time / day) + '天前'
      //   } else if (time / hour >= 1) {
      //     result = parseInt(time / hour) + '小时前'
      //   } else if (time / minute >= 1) {
      //     result = parseInt(time / minute) + '分钟前'
      //   } else {
      //     result = '刚刚'
      //   }
      //   return result
      // },

      handlePackup(item) {
        document.querySelector('#id' + item.Id).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
        item.showAllBtn = true
      },

      delDone(index) {
        this.list.splice(index, 1)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .html {
    word-break: break-all;
  }
</style>
